import React, { useState } from "react";
import "./Product_Info_List_View.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import Red_Outline_Btn from "../common_btn/red_outline_btn/Red_Outline_Btn";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import IncrementDecrementBtn from "../Increment_Decrement_Btn/Increment_Decrement_Btn";
import { useNavigate } from "react-router-dom";

import Heart_icon from "../heart_icon/Heart_icon";
import { encodeId } from "../../../utils/common";
import Select_Product_Cart_Modal from "../common_modal/select_product_by_weight_modal/Select_Product_By_Cart_Modal";

const Product_Info_List_View = ({ products }) => {
  const navigate = useNavigate();

  const [favouriteProduct, setFavouriteProduct] = useState();
  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);

  const [selectedVariant, setSelectedVariant] = useState({});
  const [variant, setVariant] = useState({});

  return (
    <section className="Product_Info_List_View">
      <div className="wishlist_cart_holder">
        <div
          className="left_side"
          onClick={() => navigate(`/product-description/${encodeId(products?.id)}`)}
        >
          <div className="img_holder">
            <img
              src={process.env.REACT_APP_IMG_URL + products?.image}
              alt={products?.name}
            />
          </div>
        </div>

        <div className="right_side">
          <div className="top_section">
            <div className="rating_div">
           
              <Heart_icon product={products} />
             
            </div>
          </div>

          <div className="footer_div">
            <div className="footer_left_side">
              <div
                className="product_name"
                onClick={() => navigate(`/product-description/${encodeId(products?.id)}`)}
              >
                <p>{products?.name}</p>
              </div>

              <div className="price_section">
                <div className="selling_price">
                  <p>₹ {products?.Product_Variants[0]?.price}</p>
                </div>

                <div className="mrp">
                  <p>₹ {products?.Product_Variants[0]?.mrp}</p>
                </div>

                {/* <div className='discount'>
                                            <p>{product?.discount}</p>
                                        </div> */}
              </div>

              {/* <div className='sub_text_div'>
                                        <p className='sub_text'>{product?.sub_text}</p>
                                    </div> */}
            </div>

            <div className="footer_right_side">
              <div className="footer_btn_holder">
                <div className="kilo_main_div">
                  <div
                    className="kilo_div"
                    onClick={() => Setaddcartmodal(true)}
                  >
                    <div>
                      <p className="kilo_text">{products?.Unit?.name}</p>
                    </div>
                    <div>
                      <p>
                        <FontAwesomeIcon
                          icon={faSortDown}
                          className="down_icon"
                        />
                      </p>
                    </div>
                  </div>
                </div>
                <div className="btn_holder">
                  {!products?.outofstock ? (
                    <>
                      {!showIncrement ? (
                        <div className="">
                          <Green_Btn
                            btn_name="Add to Cart"
                            leftIcon={faBasketShopping}
                            onClick={() => {
                              setShowIncrement(true);
                              Setaddcartmodal(true);
                            }}
                          />
                        </div>
                      ) : (
                        <div className="">
                          <IncrementDecrementBtn />
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="">
                      <Red_Outline_Btn btn_name="Out of Stock" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text_div">
          <div className="discont_div">
            <p className="discount_text">
              {Math.round(
                ((products?.Product_Variants[0]?.mrp -
                  products?.Product_Variants[0]?.price) /
                  products?.Product_Variants[0]?.mrp) *
                  100
              )}
              % Off
            </p>
          </div>
        </div>
      </div>
      <Select_Product_Cart_Modal
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        product={products}
        show={addcartmodal}
        onHide={() => Setaddcartmodal(false)}
      />
    </section>
  );
};

export default Product_Info_List_View;
